import { render, staticRenderFns } from "./PopoverStepMover.vue?vue&type=template&id=b796e57c&scoped=true&"
import script from "./PopoverStepMover.vue?vue&type=script&lang=js&"
export * from "./PopoverStepMover.vue?vue&type=script&lang=js&"
import style0 from "./PopoverStepMover.vue?vue&type=style&index=0&id=b796e57c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b796e57c",
  null
  
)

export default component.exports